module.exports = __webpack_public_path__ + "img/etc-safe-checkbox.7d40cd38.svg";